// PersistentContext.js
import React, { createContext, useState, useEffect } from 'react';

const PersistentContext = createContext();

const PersistentProvider = ({ children }) => {
  const [globalState, setGlobalState] = useState(() => {
    const savedState = localStorage.getItem('globalState');
    return savedState ? JSON.parse(savedState) : {};
  });

  useEffect(() => {
    localStorage.setItem('globalState', JSON.stringify(globalState));
  }, [globalState]);

  return (
    <PersistentContext.Provider value={{ globalState, setGlobalState }}>
      {children}
    </PersistentContext.Provider>
  );
};

export { PersistentContext, PersistentProvider };
